export { k6Meta } from './meta';



// WEBPACK FOOTER //
// ../../../../src/metas/k6/index.ts